export default __webpack_public_path__ + "static/media/Benz.1d0f5c26.png";